// Imported first in index.js, so it is evaluated before any module that reads
// the login role at import time (config/typecheck.js). Keep its import chain
// free of typecheck.
import { purgeExpiredB2BSessionOnBoot } from "./utils/sessionGuard";

purgeExpiredB2BSessionOnBoot();
